import { Clock, FileText, UserPlus } from 'lucide-react';
import { format, parseISO } from 'date-fns';
import { ar } from 'date-fns/locale';
import { UserRequest } from '../types/request';

interface RequestsListProps {
  requests: UserRequest[];
}

export function RequestsList({ requests }: RequestsListProps) {
  if (requests.length === 0) {
    return (
      <div className="text-center p-8 bg-white rounded-lg shadow-sm">
        <p className="text-gray-500">لا توجد طلبات حالياً</p>
      </div>
    );
  }

  return (
    <div className="space-y-4">
      {requests.map((request) => (
        <div key={request.id} className="bg-white p-4 rounded-lg shadow-sm">
          <div className="flex items-start gap-4">
            <div className={`p-2 rounded-lg ${
              request.type === 'add_child' ? 'bg-blue-100 text-blue-600' : 'bg-green-100 text-green-600'
            }`}>
              {request.type === 'add_child' ? (
                <UserPlus className="h-5 w-5" />
              ) : (
                <FileText className="h-5 w-5" />
              )}
            </div>
            <div className="flex-1">
              <div className="flex items-center justify-between">
                <h3 className="text-sm font-medium text-gray-900">
                  {request.type === 'add_child' ? 'طلب إضافة مولود' : 'طلب إضافة من أنت'}
                </h3>
                <span className={`text-xs px-2 py-1 rounded-lg ${
                  request.status === 'pending' ? 'bg-yellow-100 text-yellow-800' :
                  request.status === 'approved' ? 'bg-green-100 text-green-800' :
                  'bg-red-100 text-red-800'
                }`}>
                  {request.status === 'pending' ? 'قيد المراجعة' :
                   request.status === 'approved' ? 'تمت الموافقة' : 'مرفوض'}
                </span>
              </div>
              <p className="mt-1 text-sm text-gray-600">
                {request.type === 'add_child' ? request.child_name : request.personalInfo?.description}
              </p>
              <div className="flex items-center mt-2 text-xs text-gray-500">
                <Clock className="h-3 w-3 ml-1" />
                {format(parseISO(request.created_at), 'PPpp', { locale: ar })}
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}